import { AuditLog } from '@/generated/graphql';
import {
  AuditLogAction,
  AuditLogActionMap,
  AuditLogEntityType,
  AuditLogEntityTypeMap,
  AuditLogSubject,
} from '@/models/audit-log.models';
import { UTC_ZONE } from '@/models/time.models';
import { createSortingButton } from '@/utils/table.function';
import { ColumnDef } from '@tanstack/react-table';
import { DateTime } from 'luxon';
import { ReactNode } from 'react';
import { Link } from 'react-router';

export function createPathFromLog(log: AuditLog): ReactNode {
  const entities = log.entities as AuditLogSubject[];

  const entityPaths: Record<string, string> = {
    [AuditLogEntityType.DEVICE]: '/devices',
    [AuditLogEntityType.SITE]: '/sites',
    [AuditLogEntityType.CUSTOMER]: '/customers',
  };

  return (
    <div className="flex gap-1">
      {entities.map((e, idx) => {
        const entity = e.entity as AuditLogEntityType;
        const basePath = entityPaths[entity];
        const content = basePath ? (
          <Link to={`${basePath}/${e.id}`} className="underline">
            {AuditLogEntityTypeMap[entity]}
          </Link>
        ) : (
          AuditLogEntityTypeMap[entity]
        );

        return (
          <div key={idx}>
            {content}
            {idx < entities.length - 1 && ','}{' '}
          </div>
        );
      })}
    </div>
  );
}
export const auditHistoryColumns: ColumnDef<AuditLog>[] = [
  {
    accessorKey: 'createdAt',
    header: ({ column }) => {
      return createSortingButton(column, 'Time');
    },
    cell: ({ row }) => {
      return DateTime.fromISO(row.original?.createdAt, {
        zone: UTC_ZONE,
      })
        .toLocal()
        .toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS);
    },
    size: 100,
  },
  {
    accessorKey: 'actor',
    header: ({ column }) => {
      return createSortingButton(column, 'Actor');
    },
    cell: ({ row }) => {
      return row.original.aspNetUser?.userName;
    },
    size: 100,
  },

  {
    accessorKey: 'action',
    header: ({ column }) => {
      return createSortingButton(column, 'Action');
    },
    cell: ({ row }) => {
      return AuditLogActionMap[row.original?.action as AuditLogAction];
    },
    size: 100,
  },

  {
    accessorKey: 'entities',
    header: 'Entities',
    cell: ({ row }) => {
      return createPathFromLog(row.original);
    },
    size: 200,
  },
];
